import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, PHONE, TEL, scrollToId, EASE } from "./data";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled ? "border-b border-[var(--line)] bg-[#0b0b0c]/80 backdrop-blur-xl" : "border-b border-transparent"}`}
    >
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <button data-testid="nav-logo" onClick={() => window.scrollTo({ top: 0 })} aria-label="Warrior Towing home">
          <Logo />
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-link-${n.id}`}
              onClick={() => scrollToId(n.id)}
              className="group relative font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 transition-colors hover:text-white"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[var(--signal)] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>
        <a
          href={TEL}
          data-testid="nav-phone-link"
          className="flex items-center gap-2 bg-[var(--signal)] px-4 py-2.5 font-display text-base font-extrabold uppercase tracking-wide text-[var(--ink)] transition-transform duration-300 hover:-translate-y-0.5 sm:text-lg"
        >
          <Phone className="h-4 w-4" strokeWidth={2.5} />
          <span className="hidden sm:inline">{PHONE}</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </motion.header>
  );
};
